import ArticleCard from "@/components/articleCard";
import Divider from "@/components/divider";
import { AuthoredContentItem } from "@/types/common";
import styles from "./template3Column.module.scss";

type Template3ColumnProps = {
  col1Articles: AuthoredContentItem[];
  col2Articles: AuthoredContentItem[];
  col3Articles: AuthoredContentItem[];
};

const renderColumn = (articles: AuthoredContentItem[]) => {
  return articles.map((article, idx) => (
    <div key={article.id}>
      <ArticleCard
        author={article.author}
        image={article.thumbnailImageUrl?.url}
        link={`/${article.slug}`}
        origin="author_list"
        publishedOn={article.modifiedDate}
        sportName={article.sport.name}
        sportSlug={article.sport.slug}
        title={article.title}
        displayHorizontal
      />
      {idx < articles.length - 1 && <Divider color="light" />}
    </div>
  ));
};

const Template3Column = ({
  col1Articles = [],
  col2Articles = [],
  col3Articles = [],
}: Template3ColumnProps) => {
  return (
    <div className={styles.container}>
      <div className={styles.articleCardsContainer}>
        <div>{renderColumn(col1Articles)}</div>
        <div className={styles.divider}>
          <Divider color="light" />
        </div>
        <div>{renderColumn(col2Articles)}</div>
        <div className={styles.divider}>
          <Divider color="light" />
        </div>
        <div>{renderColumn(col3Articles)}</div>
      </div>
    </div>
  );
};

export default Template3Column;
